export default (ctx, key) => {
  let strings = {
    "confirm_remove_email": `Please confirm to remove ${ctx.email} from your profile:`,
  }
  return strings[key]
}
